<template lang="pug">
  .account-step
    //- if authenticated
    //- show filled form
    //- otherwise let user decide
    //- if he wants to login or proceed as guest

    template(v-if="isAuthenticated && ! checkout.form.account.id")
      Spinner(:size="16" :thickness="3")
    template(v-else)
      Authenticate.mb-8(
        v-if="! checkout.form.account.id && type === 'member'"
        :registration="false"
        :default-tab="tab"
        :default-email="checkout.form.account.email"
      )
        template(slot="prepend-tab")
          li
            a(href="#" @click.stop.prevent="type = 'guest'") Als Gast fortfahren

      .authentication-form(v-else)
        .panel.mb-8
          .tabs(v-if="! member.id && type === 'guest'")
            ul
              li.is-active
                a(href="#" @click.stop.prevent="type = 'guest'") Als Gast fortfahren
              li
                a(href="#" @click.stop.prevent="tab = 'signin'; type = 'member'") Anmelden
          .box
            MemberForm
            template(v-if="! addresses.length")
              hr.my-4
              AddressForm(
                label="Rechnungsadresse"
                :show-label="false"
                :show-checkbox="false"
                :active="true"
                @select="select"
              )

      .billing-addresses(v-if="addresses.length")
        h4.panel-heading Rechnungsadresse
        .panel.mb-8
          .box
            Address(
              v-for="(address, i) in addresses" :key="address.id"
              :data="address"
              :active="address.id === billingAddress.id"
              :show-divider="true"
              :show-label="false"
              @select="select"
            )
            AddressForm(
              label="Rechnungsadresse"
              :show-label="false"
              :active="billingAddress.id.startsWith('new:')"
              @select="select"
            )
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';
import AddressForm from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/AddressForm';
import MemberForm from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/MemberForm';
import Address from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/Address';

export default {
    name: 'AccountStep',
    props: {
        // form: {
        //   type: Object,
        //   required: true
        // }
    },
    data: () => ({
        type: 'guest',
        tab: 'signin'
    }),
    components: {
        Authenticate,
        MemberForm,
        AddressForm,
        Address
    },
    watch: {
        type() {
            // block stepper if login form is visible
            if (!this.checkout.form.account.id && this.type === 'member') this.$emit('block');
            else this.$emit('unblock');
        },
        'checkout.form.account.id'() {
            // block stepper if login form is visible
            if (!this.checkout.form.account.id && this.type === 'member') this.$emit('block');
            else this.$emit('unblock');
        },
        'member.id'(id) {
            this.initCheckout();
            if (id) this.type = 'member';
            else this.type = 'guest';
        }
    },
    computed: {
        addresses() {
            return this.addressOptions.billing;
        },
        billingAddress: {
            get() {
                return this.checkout.form.account.billing_address;
            },
            set(value) {
                this.setBillingAddress(value);
            }
        },
        ...mapGetters({
            member: 'auth/member',
            isAuthenticated: 'auth/isAuthenticated',
            checkout: 'shop/checkout',
            addressOptions: 'shop/addressOptions'
        })
    },
    methods: {
        select(address) {
            this.billingAddress = address;
        },
        ...mapMutations({
            setBillingAddress: 'shop/setCheckoutFormBillingAddress'
        }),
        ...mapActions({
            initCheckout: 'shop/initCheckoutForm'
        })
    },
    mounted() {
        if (this.isAuthenticated && this.member) {
            this.type = 'member'; // otherwise 'guest' (default)
        }
    }
};
</script>

<style lang="sass" scoped>
.account-step
  flex-grow: 1
  @screen md
    flex-grow: 0
.tabs a
  text-decoration: none
</style>
